const touchMap = new WeakMap()

/**
 * @vue-data {Object} formServerErrors - Server errors object.
 * @vue-event clearFormServerErrors - Reset full object of server errors.
 * @vue-event deleteServerError - Delete field error messages from `formServerErrors` by prop.
 * @vue-event delayTouch - Delayed validation errors. Reset backend field error messages.
 */
export default {
  data() {
    return {
      formServerErrors: {},
    }
  },
  methods: {
    hasProp(prop) {
      if (prop && this.formServerErrors) {
        return prop in this.formServerErrors
      }
    },
    clearFormServerErrors() {
      if (this.formServerErrors) {
        this.formServerErrors = {}
      }
    },
    deleteServerError(prop) {
      if (this.hasProp(prop)) {
        this.$delete(this.formServerErrors, prop)
      }
    },
    serverError(prop) {
      if (this.hasProp(prop)) {
        return this.formServerErrors[prop]
      }

      return []
    },

    reset($v, prop) {
      $v.$reset()

      this.deleteServerError(prop)
    },

    delayTouch($v, prop) {
      this.reset($v, prop)

      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v))
      }
      touchMap.set($v, setTimeout($v.$touch, 1000))
    },
  },
}
